import { TitleEntityForm } from '../../features/TitleEntityForm';
import { apiRequests } from '../../shared/api/apiRequests';

const EditCategoryOfPortfolioPage = () => (
  <TitleEntityForm
    load={apiRequests.portfolio.getCategory}
    update={apiRequests.portfolio.updateCategory}
    backTo="/portfolio/categories"
    savedText="Категория сохранена"
  />
);

export default EditCategoryOfPortfolioPage;
